<div class="hold-transition login-page" [ngClass]="bgclass">
<div class="login-box">
  <div class="login-logo">
    <a style="color: white;"><b>Prisma</b><sup>CRM</sup> </a>
  </div>
  <!-- /.login-logo -->
  <div class="card" style="background-color: #e9ecef;">
    <div class="card-body login-card-body">
      <p class="login-box-msg">Sign in to start your session</p>

      <form [formGroup]="loginForm" (ngSubmit)="login();">
        <div class="input-group mb-3">
          <input type="text" class="form-control" placeholder="email" formControlName="email" >
          <div class="input-group-append">
            <div class="input-group-text">
              <span class="fas fa-envelope"></span>
            </div>
          </div>
        </div>
        <div class="input-group mb-3">
          <input type="password" class="form-control" placeholder="Password" formControlName="password" >
          <div class="input-group-append">
            <div class="input-group-text">
              <span class="fas fa-lock"></span>
            </div>
          </div>
        </div>
        <div class="row">

          <p class="login-box-msg" style="color: red;" *ngIf="error">*Please enter correct username and password</p>

          <p class="login-box-msg" style="color: red;" *ngIf="serverError">*Invalid username or password</p>

          <p class="login-box-msg" style="color: red;" *ngIf="timeOut">*Timeout. Please try again</p>

          <div class="col-12" *ngIf="!isLoading">
            <button type="submit" class="btn btn-primary btn-block">Login</button>
          </div>
          <div class="spinner-border text-primary" role="status" style="margin: auto;" *ngIf="isLoading">
            <span class="sr-only">Loading...</span>
          </div>

        </div>
      </form>
    </div>
    <!-- /.login-card-body -->
  </div>
</div>
</div>
